import { createContext, useContext, useState, useCallback } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CartContext = createContext();

export function CartProvider({ children }) {
  const [items, setItems] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const fetchCart = useCallback(async () => {
    try {
      const res = await fetch(`${API}/cart`, { credentials: "include" });
      if (res.ok) setItems(await res.json());
    } catch {}
  }, []);

  const addToCart = async (productId, quantity, instagramLink, instagramLink2 = null, instagramLinksExtra = null, extra = null) => {
    const body = { product_id: productId, quantity, instagram_link: instagramLink };
    if (extra?.target_url) body.target_url = extra.target_url;
    if (extra?.custom_comments) body.custom_comments = extra.custom_comments;
    if (extra?.selected_emoji_service_id) body.selected_emoji_service_id = extra.selected_emoji_service_id;
    if (extra?.selected_emoji) body.selected_emoji = extra.selected_emoji;
    if (instagramLink2) body.instagram_link_2 = instagramLink2;
    if (instagramLinksExtra && instagramLinksExtra.length > 0) body.instagram_links_extra = instagramLinksExtra;
    const res = await fetch(`${API}/cart`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      const err = await res.json();
      throw new Error(err.detail);
    }
    await fetchCart();
    setSidebarOpen(true);
    return true;
  };

  const removeItem = async (cartItemId) => {
    await fetch(`${API}/cart/${cartItemId}`, { method: "DELETE", credentials: "include" });
    setItems((prev) => prev.filter((i) => i.cart_item_id !== cartItemId));
  };

  const itemCount = items.length;

  return (
    <CartContext.Provider value={{ items, setItems, sidebarOpen, setSidebarOpen, fetchCart, addToCart, removeItem, itemCount }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be inside CartProvider");
  return ctx;
}
